module.exports = __webpack_public_path__ + "static/media/google-play-badge-11.4b624970.png";